// extracted by mini-css-extract-plugin
export default {"itemLink":"CartItem_itemLink__IDs9B","itemTotal":"CartItem_itemTotal__GUun+"};